module.exports = __webpack_public_path__ + "img/alfie-a3.846e93ba.png";